import React from 'react';
import { MdOutlineSave } from 'react-icons/md';
import { useComposition, useWorkspace } from '../../context';
import FramiButton from '../common/FramiButton';
import { useIntl } from 'react-intl';


const SaveCompositionButton = () => {
    const { saveEditedComposition } = useWorkspace();
    const { currentComp } = useComposition();
    const intl = useIntl();

    const handleClick = async () => {
        saveEditedComposition();
    }

    return (
        <FramiButton
            className={'action-button uppercase'}
            dataPh={'floating bottom save composition'}
            leftIcon={<MdOutlineSave />}
            variant="primary"
            disabled={currentComp?.frames_json?.length === 0}
            title={intl.formatMessage({ id: 'studio.button.action.save_composition' })}
            dataCy={'save_composition'}
            onClick={handleClick}
        />
    );
};

export default SaveCompositionButton;
